module.exports = ".delete {\n  margin-right: 1.5vw;\n  cursor: pointer;\n}\n\n.alert {\n  padding: 10px;\n  margin-bottom: 2vh;\n  width: 100%;\n  border: 1px solid red;\n  border-radius: 0;\n}\n\n.alert p {\n  color: red;\n}\n\n.alert a {\n  color: red;\n  text-decoration: underline;\n}\n\n.padd {\n  padding: 2vh 0;\n}\n\n.cap {\n  margin-bottom: 2vh;\n}"


//////////////////
// WEBPACK FOOTER
// ./src/app/user/_sign-in/sign-in.component.scss
// module id = ./src/app/user/_sign-in/sign-in.component.scss
// module chunks = main